import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { CopyIcon } from '$common/icons/copy'
import { OpenInNewIcon } from '$common/icons/open-in-new'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { copyToClipboard } from '$func/clipboard'
import { showHashtagSavedInMemorySnackbar } from '$comp/snackbars'
import { roomSearchApi } from '$comp/_app/components/chat/room'
import { t } from '$i18n'

interface Props {
  isOpen: boolean
  hashtag: string
}

export function HashtagMenu({ isOpen, hashtag }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.common.copy')}
        onClick={async () => {
          copyToClipboard(hashtag)
          await closeCurrentModal()
          showHashtagSavedInMemorySnackbar()
        }}
      >
        <CopyIcon />
      </PopupMenuItem>

      <PopupMenuItem
        text={t('menu.link.open')}
        onClick={async () => {
          await closeCurrentModal()
          roomSearchApi.handleSearch(hashtag)
        }}
      >
        <OpenInNewIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
